import React, { memo } from 'react';

import { ContainerDeleteCard, Ring1, Ring2, Wrapper } from './Spinner.styles';

export default memo(({ isLoading }: { isLoading: boolean }) => {
  const obtainedClassName = isLoading ? 'container-spinner-active' : 'container-spinner';

  return (
    <ContainerDeleteCard isLoading={isLoading} className={obtainedClassName}>
      <Wrapper>
        <Ring1 className="spinner__ring-1" />
        <Ring2 className="spinner__ring-2" />
      </Wrapper>
    </ContainerDeleteCard>
  );
});
